import { go, html, strMap, zipWithIndexL } from 'fxjs/es';
import { NessAppPlusProductTmplS } from '../../../Product/S/Tmpl/module/NessAppPlusProductTmplS.js';

export const live = (lives) => {
  return html` <section class="ness-live">
    ${go(
      lives,
      zipWithIndexL,
      strMap(([index, { title, description, product, platform, iframe_url, stream_url }]) => {
        const queryString = iframe_url.includes('?') ? '&' : '?';

        return html`
          <div class="ness-live__row">
            <div class="ness-live__column">
              <div class="ness-live__iframe-box">
                ${platform === 'youtube'
                  ? html` <iframe
                      data-src="${iframe_url}${queryString}mute=1&autoplay=${1}"
                      class="ness-live__iframe don_lazy"
                      width="100%"
                      height="100%"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen="false"
                    ></iframe>`
                  : platform === 'afreecatv'
                  ? html` <iframe
                      data-src="${iframe_url}${queryString}autoplay=${true}"
                      class="ness-live__iframe don_lazy"
                      width="100%"
                      height="100%"
                      frameborder="0"
                      allowfullscreen="false"
                    ></iframe>`
                  : html` <iframe
                      data-src="${iframe_url}${queryString}muted=true&autoplay=${true}"
                      class="ness-live__iframe don_lazy"
                      frameborder="0"
                      allowfullscreen="false"
                      scrolling="no"
                      height="100%"
                      width="100%"
                    ></iframe>`}
              </div>
            </div>
            <div class="ness-live__column">
              ${NessAppPlusProductTmplS.nessLiveProductTmpl(product, title, true, 'ness-live__product')}
            </div>
          </div>
        `;
      }),
    )}
  </section>`;
};
